/* eslint-disable no-nested-ternary */
import { useScreenSize } from '@hooks';
import { Flex, Link, theme, Typography } from '@styles';
import { object } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router-dom';

import { breadcrumbsLayoutByVariant } from './Breadcrumbs.layoutProps';

const Breadcrumbs = ({ containerProps }) => {
  const { i18n } = useTranslation();
  const matches = useMatches();
  const { device } = useScreenSize();

  const layout = breadcrumbsLayoutByVariant[device || 'desktop'];

  const breadcrumbs = matches?.[matches.length - 1]?.handle?.crumbs;
  const lastIndex = breadcrumbs.length - 1;
  const matchParams = matches?.[matches.length - 1]?.params;

  return (
    <Flex
      flexWrap="wrap"
      gap={16}
      mt={layout?.mt}
      py={layout?.py}
      zIndex={90}
      {...containerProps}
    >
      {breadcrumbs?.map((crumb, index) => {
        const title = crumb?.param
          ? crumb?.title(matchParams[crumb?.param])?.toUpperCase()
          : i18n.t(crumb?.title)?.toUpperCase();

        if (!title) {
          return null;
        }

        return (
          <React.Fragment key={index}>
            <Link
              color={theme.colors.white[index === lastIndex ? 100 : 20]}
              lineHeight="17px"
              to={
                // eslint-disable-next-line no-unsafe-optional-chaining
                index === breadcrumbs?.length - 1
                  ? '.'
                  : crumb?.param
                    ? crumb?.path?.replace(
                        `:${crumb?.param}`,
                        matchParams[crumb?.param]
                      )
                    : crumb?.path
              }
            >
              {title}
            </Link>
            {index !== lastIndex && (
              <Typography
                color={theme.colors.white[index === lastIndex ? 100 : 20]}
                variant="MS-semibold-s16-lh17"
              >
                /
              </Typography>
            )}
          </React.Fragment>
        );
      })}
    </Flex>
  );
};

Breadcrumbs.propTypes = {
  containerProps: object,
};

Breadcrumbs.defaultProps = {
  containerProps: {},
};

export default Breadcrumbs;
